
import './style.scss'

interface LabeledSelectMenuProps {
	label: string
	options: string[]
	onChange: (newOption: string) => void
	value?: string
	disabled?: boolean
}

function LabeledSelectMenu({label, options, onChange, value, disabled}: LabeledSelectMenuProps) {

	return (
		<div className='labeled-select-menu-wrap'>
			<select
				className='labeled-select-menu-select'
				onChange={(event) => {
					onChange(event.target.value)
				}}
				value={value}
				disabled={disabled}
			>
				{options.map((option, index) => 
					<option 
						value={option}
						key={`selectOption${index}`}
					>{option}</option>
				)}
			</select>
			<span className='labeled-select-menu-inner-label'>{label}</span>
		</div>
	)
}

export default LabeledSelectMenu